// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:24
import { CStampProcedureAction_abstract } from './../abstract/SagaSchema/CStampProcedureAction_abstract';
export class CStampProcedureAction extends CStampProcedureAction_abstract {}
